import createAsyncReducer from '@/store/createAsyncReducer.js';

const initialStateReducer = createAsyncReducer({
    name: 'initialState',
    initialState: {
        done: false,
        loading: false
    },
    reducers: (create) => ({
        setInitialState: create.asyncThunk(
            async (dataEnv) => {
                return dataEnv;
            },
            {
                pending: (state, action) => {
                    state.loading = true;
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.done = true;
                },
                rejected: (state, action) => {
                    state.loading = false;
                }
            }
        )
    })
});

export default initialStateReducer;